// extracted by mini-css-extract-plugin
export default {"control":"Product_control__C1wlm","richText":"Product_richText__qGwab"};